import React, { createContext } from "react"
import { defaultIntl, isAu, window } from "../utils"

export const globalContext = createContext({
  intl: defaultIntl,
  country: isAu() ? "au": "ca"
})